import axios from 'axios'
import {authHeaders} from './authorize'

const SHORTURL_BASE = 'https://qr1.to/';

export async function shortenUrl(url) {
  let headers = {'content-type': 'application/json', ...await authHeaders()};
  console.log(headers);
  let response = await axios.post(SHORTURL_BASE, {redir: url}, {headers});
  return response.data.shorturl;
}

/**
 * Return whether url is valid to be shortened
 *
 * @param {*} url
 */
export function validUrl(url) {
  try {
    let u = new URL(url);
    return u.protocol.match(/https?:/i);
  } catch(e) {
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/services/shorturl.js